module.exports = __webpack_public_path__ + "static/img/welcome-poster.e9bccf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/welcome-poster.jpg
// module id = 3XHR
// module chunks = 25